import { formatMoney } from '@belong/common';
import { Button, Text } from '@belong/ui';
import ModalV2 from 'components/Modal/ModalV2/ModalV2';
import PaymentMethodContainer from 'containers/PaymentMethodContainer/PaymentMethodContainer';
import { PaymentPreference, PaymentPriority } from 'models/enums';
import { QuestionsOrConcernsModalFooter } from 'post-inspection/components/question-or-concern-modal-footer/question-or-concern-modal-footer';
import { STRINGS } from 'post-inspection/constants/strings';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectFullUser } from 'store/redux/user/selectors';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';
import { getString } from 'strings';

const PlacementFeeModal = ({
  isVisible,
  isLoading,
  onHide,
  onPayNow,
  placementFeeAmount,
}) => {
  const fullUser = useSelector(selectFullUser);
  const hasPaymentMethod = !!fullUser?.getPaymentMethodFor(
    PaymentPreference.Maintenance,
    PaymentPriority.Primary,
  );

  return (
    <ModalV2
      closeButton
      noPadding
      onHide={onHide}
      showSpinner={isLoading}
      show={isVisible}
    >
      <div className="flex w-full flex-col items-center pt-xl sm:pt-3xl">
        <div className="flex w-full flex-col items-center">
          <div className="px-sm text-center sm:max-w-[340px] md:max-w-[700px]">
            <Text fontWeight="semibold" variant="h2">
              {getString(
                POST_INSPECTION_FLOW_STRINGS[
                  'initial_listing.placement_fee_modal.title'
                ],
                {
                  amount: formatMoney(placementFeeAmount, 'DOLLARS_WITH_CENTS'),
                },
              )}
            </Text>
          </div>

          <div className="px-sm pt-xs text-center sm:max-w-[510px]">
            <Text>
              {
                POST_INSPECTION_FLOW_STRINGS[
                  'initial_listing.placement_fee_modal.subtitle'
                ]
              }
            </Text>
          </div>

          <div className="mt-xl w-full">
            <div className="mb-lg px-sm">
              <Text fontWeight="semibold" className="mb-sm">
                {STRINGS['payment-method']}
              </Text>
              <PaymentMethodContainer
                maintenanceOnly
                defaultPriority={PaymentPriority.Primary}
                hasLabels={false}
                variant="secondary"
                isMaintenance
              />
            </div>

            <QuestionsOrConcernsModalFooter>
              <Button disabled={!hasPaymentMethod} onClick={onPayNow}>
                {
                  POST_INSPECTION_FLOW_STRINGS[
                    'initial_listing.placement_fee_modal.pay_now'
                  ]
                }
              </Button>
            </QuestionsOrConcernsModalFooter>
          </div>
        </div>
      </div>
    </ModalV2>
  );
};

PlacementFeeModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onPayNow: PropTypes.func.isRequired,
  placementFeeAmount: PropTypes.number,
};

export default PlacementFeeModal;
